import { useEffect, useState } from "react";
import { GridColumnDefs } from "../../../../models/Grid/gridColumnDefs";
import Grid from "../../../shared/Grid/Grid";
import { communicationLogs_LABELS } from "../../../../constants/labels/CommunicationLogs";
import {
  useGetBpCommunicationLogsHistoryQuery,
  useGetDocumentNamesQuery,
} from "../../../../services/rtkQueryServices/communicationLogsService";
import "./CommunicationLogsHistoryGrid.scss";
import { DELIVERY_STATUS_TYPE } from "../../../../constants/enums/deliveryStatusTypes";
import { Utility } from "../../../../utils/Utility";
function BpCommunicationLogsHistoryGrid(Props: any) {
  const { data } = Props;

  const DeliveryStatus = (props: any) => {
    return (
      <>
        <div
          className={
            " d-flex justify-content-center bold " +
            (props?.data?.deliveryStatus === DELIVERY_STATUS_TYPE.Success
              ? "green "
              : props?.data?.deliveryStatus === DELIVERY_STATUS_TYPE.Failed
              ? "red "
              : "yellow")
          }
        >
          {props?.data?.deliveryStatus === DELIVERY_STATUS_TYPE.Queued ||
          props?.data?.deliveryStatus === DELIVERY_STATUS_TYPE.InProgress
            ? "In Progress"
            : DELIVERY_STATUS_TYPE[props?.data?.deliveryStatus]}
        </div>
      </>
    );
  };
  const CreatedDate = (props: any) => {
    return Utility.ConvertToDateTime(props?.data?.createdDate);
  };
  const columnDefs: GridColumnDefs[] = [
    {
      headerName: communicationLogs_LABELS.initiatedBy,
      field: "initiatedBy",
      align: "center",
    },
    {
      headerName: communicationLogs_LABELS.date,
      field: "date",
      cellRenderer: CreatedDate,
      align: "center",
    },
    {
      headerName: communicationLogs_LABELS.status,
      field: "deliveryStatus",
      cellRenderer: DeliveryStatus,
    },
    {
      headerName: communicationLogs_LABELS.reason,
      field: "failedReason",
      align: "center",
    },
  ];

  const { data: communicationLogsData, isError } =
    useGetBpCommunicationLogsHistoryQuery({
      notificationId: data.notificationId,
      processID: data.processId,
    });
  const {
    data: documentNames,
    isLoading: isDocumentsLoading,
    isError: isDocumentsError,
  } = useGetDocumentNamesQuery({
    notificationDataId: data.notificationId,
  });
  const [rowData, setRowData] = useState<any>([]);
  const [rowcount, setRowCount] = useState<number>(0);

  useEffect(() => {
    if (isError) {
      setRowData([]);
      setRowCount(0);
    } else {
      setRowData(
        communicationLogsData?.data?.communicationLogDetails
          ? communicationLogsData?.data?.communicationLogDetails
          : []
      );
      communicationLogsData?.data?.communicationLogDetails &&
        setRowCount(communicationLogsData?.data?.totalCount);
    }
  }, [communicationLogsData, isError]);

  return (
    <div className="status-logs-wrapper p-3 mx-2">
      <div className="pb-5 d-flex flex-column gap-5 p-5 mb-5  logs-details">
        <div className="d-flex gap-4">
          <div className="d-flex flex-column flex-grow-1 clinic-details-group">
            <div className="clinic-label">
              {communicationLogs_LABELS.clinicName}
            </div>
            <div className="clinic-info">{data?.clinicName}</div>
          </div>
          <div className="d-flex flex-column flex-grow-1 clinic-details-group">
            <div className="clinic-label">
              {communicationLogs_LABELS.bpSiteId}
            </div>
            <div className="clinic-info">{data?.bpSiteId}</div>
          </div>
          <div className="d-flex flex-column flex-grow-1 clinic-details-group">
            <div className="clinic-label">
              {communicationLogs_LABELS.finalisedBy}
            </div>
            <div className="clinic-info">{data?.finalisedBy}</div>
          </div>
        </div>
        <div className="d-flex gap-4">
          <div className="d-flex flex-column flex-grow-1 clinic-details-group">
            <div className="clinic-label">
              {communicationLogs_LABELS.patientName}
            </div>
            <div className="clinic-info">{data?.recipientName}</div>
          </div>
          <div className="d-flex flex-column flex-grow-1 clinic-details-group nowrap">
            <div className="clinic-label">
              {communicationLogs_LABELS.documentsSent}
            </div>
            <div className="clinic-info">
              {isDocumentsError && (
                <span className="error-message">
                  Unable to load documents sent
                </span>
              )}
              {!isDocumentsLoading &&
                !isDocumentsError &&
                (documentNames?.data ?? "-")}
            </div>
          </div>
          <div className="d-flex flex-column clinic-details-group">
            <div className="clinic-label"></div>
          </div>
        </div>
      </div>
      <Grid
        columnDefs={columnDefs}
        rowData={rowData}
        rowCount={rowcount}
        serverSideSorting
        minGridHeight="160px"
        gridHeight="unset"
        uniqueIdentifierFieldName={"id"}
      ></Grid>
    </div>
  );
}

export default BpCommunicationLogsHistoryGrid;
